<template>
  <div :class="['search-teams__list', { card: withCard }]">
    <div class="search-teams__total" v-if="teams.length > 0">
        {{ total }}
        {{ total === 1 ? 'team' : 'teams' }}
    </div>
    <div class="search-teams__item" v-for="(team, index) in teams"
      :key="team.teamId || team.id || index">
      <team-preview :team-data="team" :is-active="false" />

      <el-divider v-if="showDividers && index < teams.length - 1" />

      <el-pagination v-if="teams && teams.length > 0 && limit && limit > 0" layout="prev, pager, next" :total="total" hide-on-single-page
        :page-size="limit" :current-page="currentPage" @current-change="onNavigate" />
    </div>

    <div class="search-teams__empty-text" v-if="total !== null && teams.length === 0">
      <slot name="empty">There are no teams matching your search query</slot>
    </div>
  </div>
</template>

<script>
import TeamPreview from '@/components/teams/TeamPreview.vue';

export default {
  name: 'TeamPreviewList',
  components: { TeamPreview },
  props: {
    teams: {
      type: Array,
      default: () => [],
      // @ts-ignore: Suppress type error for _id property
    },
    // Use null until you know the result count; shows empty message when 0
    total: {
      type: [Number, null],
      default: null,
    },
    withCard: {
      type: Boolean,
      default: true,
    },
    showDividers: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    onNavigate: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style lang="css" scoped>
  .search-teams__result {
    margin-top: var(--global-dimension-size-350);
  }

  .search-teams__total {
    font-size: var(--font-size-300);
    margin-bottom: var(--global-dimension-size-300);
  }

  .search-teams__empty-message {
    font-size: var(--font-size-300);
  }
</style>